import React from "react";

import {View, Text, ScrollView, StyleSheet, TouchableOpacity ,Platform, Alert} from "react-native";
import AntDesign from "@expo/vector-icons/AntDesign";
import Config from "../../../Config";
import {RFValue} from "react-native-responsive-fontsize";
import {Entypo, FontAwesome, FontAwesome6, Foundation, MaterialIcons} from "@expo/vector-icons";
import Feather from "@expo/vector-icons/Feather";
import AsyncStorage from "@react-native-async-storage/async-storage";
import * as Linking from 'expo-linking';
import Ionicons from "@expo/vector-icons/Ionicons";

const Other =({navigation})=>{
    const Logout = async () => {
        await AsyncStorage.removeItem("token");
        navigation.reset({
            index: 0,
            routes: [{ name: "Splash" }],
        });
    }



    const showConfirmDialog = () => {

        if (Platform.OS === 'web') {
            // For web
            const result = window.confirm('آیا مطمئن هستید؟');
            if (result) {
              Logout();
            } else {
                return  false;
            }
        } else {
            Alert.alert(
                ' خروج',
                'آیا   مطمئن هستید؟',
                [
                    {
                        text: 'لغو',
                        // onPress: () => Logout(),
                        style: 'cancel',
                    },
                    {
                        text: 'تأیید',
                        onPress: () => Logout(),
                    },
                ],
                { cancelable: false }
            );

        }


    };


    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <Text style={styles.title}>
                    سایــر
                </Text>
            </View>
            <ScrollView >
                <View style={styles.content}>
                    <TouchableOpacity onPress={()=>{navigation.navigate('Profile')}} style={styles.item}>
                        <AntDesign name="user" size={RFValue(25)} color="#FFF" />
                        <Text style={styles.itmtxt}>
                            پروفایل من
                        </Text>
                    </TouchableOpacity>

                    <TouchableOpacity onPress={()=>{navigation.navigate('Buy')}} style={styles.item}>

                        <FontAwesome name="shopping-bag" size={RFValue(25)} color="#FFF" />
                        <Text style={styles.itmtxt}>
                            دوره های خریداری شده
                        </Text>
                    </TouchableOpacity>

                    <TouchableOpacity onPress={()=>{navigation.navigate('FlashCart')}} style={styles.item}>

                        <Ionicons name="bookmark" size={RFValue(25)} color="#FFF" />
                        <Text style={styles.itmtxt}>
                            فلش کارت ها
                        </Text>
                    </TouchableOpacity>

                    <TouchableOpacity style={styles.item} onPress={()=>{navigation.navigate('Contact')}} >

                        <MaterialIcons name="contact-phone" size={RFValue(25)} color="#FFF" />
                        <Text style={styles.itmtxt}>
                            ارتباط با ما
                        </Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.item} onPress={()=>{navigation.navigate('Ref')}} >

                        <Foundation name="social-skillshare" size={RFValue(25)} color="#FFF" />
                        <Text style={styles.itmtxt}>
                           معرفی به دوستان
                        </Text>
                    </TouchableOpacity>


                    <TouchableOpacity style={styles.item} onPress={()=>{navigation.navigate('Tickets')}} >
                        <Entypo name="chat" size={RFValue(25)} color="#FFF"  />
                        <Text style={styles.itmtxt}>
                            پشتیبانی
                        </Text>
                    </TouchableOpacity>

                    <TouchableOpacity style={styles.item} onPress={()=>{navigation.navigate('About')}} >
                        <AntDesign name="infocirlceo" size={RFValue(25)} color="#FFF" />
                        <Text style={styles.itmtxt}>
                            درباره هیمورا
                        </Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.item} onPress={()=>Linking.openURL('https://himoralanguagecenter.com/rules')}>
                        <Feather name="file-text" size={RFValue(25)} color="#FFF" />
                        <Text style={styles.itmtxt}>
                            قوانین و مقررات
                        </Text>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={()=>Linking.openURL("https://cafebazaar.ir/app/com.himoralanguagecenter.app")} style={styles.item}>
                        <FontAwesome6 name="ranking-star" size={RFValue(25)} color="#FFF" />
                        <Text style={styles.itmtxt}>
                            امتیازدهی به برنامه
                        </Text>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={showConfirmDialog} style={styles.item}>
                        <MaterialIcons name="logout" size={RFValue(25)} color="#FFF" />
                        <Text style={styles.itmtxt}>
                            خروج از حساب کاربری
                        </Text>
                    </TouchableOpacity>
                </View>
            </ScrollView>

        </View>
    );
}

const styles = StyleSheet.create({

    itmtxt : {
        fontSize: RFValue(14),
        fontFamily : 'yk',
        color: 'white',
        marginRight : RFValue(20),

    },


    item : {
        flexDirection : 'row',
        flex : 1,
        width: '99%',
        justifyContent : 'flex-start',
        alignItems : 'center',

        paddingVertical: RFValue(24),
        borderBottomWidth : 1,
        borderBottomColor : '#2B3059',
    },

    content : {
        flex: 1,
        paddingHorizontal: RFValue(20),

    },

    container : {
        flex: 1,
        backgroundColor: Config.maincolor,
    },
    header: {
        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),
        paddingVertical: RFValue(14),

        shadowColor:"#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },


    title : {
        fontSize: RFValue(18),
        fontFamily : 'ykb',
        color: 'white',
    }
})


export default Other